import { render, staticRenderFns } from "./OnboardingSignature.vue?vue&type=template&id=ce503b74&scoped=true"
import script from "./OnboardingSignature.vue?vue&type=script&lang=js"
export * from "./OnboardingSignature.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSignature.vue?vue&type=style&index=0&id=ce503b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce503b74",
  null
  
)

export default component.exports